module.exports = __webpack_public_path__ + "img/guide.93d8cc5b.gif";